module.exports = __webpack_public_path__ + "step1_parent_to_child.88ccadf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_parent_to_child.jpg
// module id = a1z+
// module chunks = 0